export default function megaMenu() {
    const megaOne = document.getElementById('fndry-mega-menu-one');

    const destinationMenu = document.querySelector('.fndry-primary-nav nav');

    const submenuItems = destinationMenu ? destinationMenu.querySelectorAll('.fndry-nav__item--has-submenu') : null;

    const firstSubmenuItem = submenuItems ? submenuItems[0] : null;

    if (megaOne && firstSubmenuItem) {
        firstSubmenuItem.insertBefore(megaOne, firstSubmenuItem.lastElementChild);
        firstSubmenuItem.classList.add('fndry-nav__item--has-mega-menu');
    }
}
